module.exports = __webpack_public_path__ + "static/media/CRIM.797d1602.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CRIM.jpg
// module id = 1724
// module chunks = 1